export type Vec3 = [number, number, number];

const D2R = Math.PI / 180;

/** Sky direction in scene space: Y up, the base view azimuth is -Z, increasing azimuth turns right (+X). */
export function azAltToDirection(azDeg: number, altDeg: number, viewAzDeg: number): Vec3 {
  const rel = (azDeg - viewAzDeg) * D2R;
  const alt = altDeg * D2R;
  return [Math.cos(alt) * Math.sin(rel), Math.sin(alt), -Math.cos(alt) * Math.cos(rel)];
}

export function safeSize(width: number, height: number): { width: number; height: number } {
  const fix = (v: number): number => (Number.isFinite(v) ? Math.max(1, Math.floor(v)) : 1);
  return { width: fix(width), height: fix(height) };
}
